import { type Organization } from "@app/usecases/OrganizationUseCases";
import { atom } from "jotai";

export const orgToConfigureAtom = atom<Organization | undefined>(undefined);
export const orgToUpdateAtom = atom<Organization | undefined>(undefined);
